<template>
    <div class="flex-page">
        <a-form class="ctrl" layout="inline">

            <a-form-item label="开始时间">
                <a-date-picker v-model="search.start_time" />
            </a-form-item>

            <a-form-item label="结束时间">
                <a-date-picker v-model="search.end_time" />
            </a-form-item>



            <a-form-item label="姓名">
                <a-input style="min-width: 200px" v-model="search.name" placeholder="请输入姓名关键词"></a-input>
            </a-form-item>
            <a-form-item label="昵称">
                <a-input style="min-width: 200px" v-model="search.nickname" placeholder="请输入昵称关键词"></a-input>
            </a-form-item>
            <a-form-item label="电话">
                <a-input style="min-width: 200px" v-model="search.mobile" placeholder="请输入电话关键词"></a-input>
            </a-form-item>

            <a-form-item label="状态">
                <a-select style="min-width: 100px;" v-model="search.status">
                    <a-select-option :value="''">全部</a-select-option>
                    <a-select-option placeholder="请选择" v-for="(item, key) in orderStatus.statusArr" :key="key"
                        :value="item"> {{ item
                        }}</a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item>
                <a-button type="primary" @click="doSearch">搜索</a-button>
            </a-form-item>
        </a-form>

        <div class="article-page" style="overflow: auto;">
            <div class="list">
                <div class="statistics">共{{ amount }}条, 共{{ allMoney }}元</div>
                <a-table bordered :dataSource="list" :columns="columns" :pagination="false" size="small"
                    :rowKey="(record) => record.id">

                    <template slot="id" slot-scope="text, record">
                        beikechengId_{{ record.id }}
                    </template>


                    <template slot="weixin" slot-scope="text, record">
                        <img style="width: 40px;" :src="record.headimgurl" alt="">
                    </template>

                    <template slot="caozuo" slot-scope="text, record">
                        <a-button type="primary" @click="showCaozuo(record)">操作</a-button>
                    </template>

                </a-table>
                <a-pagination @change="onChange" :total="amount" :defaultPageSize="50" :defaultCurrent="search.now_page"
                    showQuickJumper class="margin15" />
            </div>
        </div>

        <a-modal title="操作" :visible="orderStatus.show" @ok="doCaozuo" @cancel="cancelCaozuo">
            <a-form class="" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-form-item label="状态">
                    <a-select v-model="orderStatus.status">
                        <a-select-option placeholder="请选择" v-for="(item, key) in orderStatus.statusArr" :key="key"
                            :value="item"> {{ item
                            }}</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="备注">
                    <a-textarea v-model="orderStatus.remark"></a-textarea>
                </a-form-item>
            </a-form>
        </a-modal>

    </div>
</template>
  
<style lang='scss' scoped></style>
  
<script>
import moment from 'moment'
export default {
    data() {
        return {
            formItemLayout: {
                labelCol: {
                    span: 4,
                },
                wrapperCol: {
                    span: 20,
                },
            },
            columns: [
                {
                    title: "充值ID",
                    scopedSlots: {
                        customRender: "id",
                    },
                },
                {
                    title: "姓名",
                    dataIndex: "huiyuanName",
                },
                {
                    title: "昵称",
                    dataIndex: "nickname",
                },
                {
                    title: "微信",
                    scopedSlots: {
                        customRender: "weixin",
                    },
                },
                {
                    title: "电话",
                    dataIndex: "mobile",
                },


                {
                    title: "等级",
                    dataIndex: "level",
                },
                {
                    title: "城市",
                    dataIndex: "city",
                },

                {
                    title: "续费时间",
                    dataIndex: "payed_at",
                },


                {
                    title: "金额",
                    dataIndex: "money",
                },
                {
                    title: "状态",
                    dataIndex: "status",
                },
                {
                    title: "备注",
                    dataIndex: "remark",
                },
                {
                    title: "操作",
                    scopedSlots: {
                        customRender: "caozuo",
                    },
                },
            ],
            search: {
                start_time: null,
                end_time: null,
                name: '',
                nickname: '',
                mobile: '',
                status: ''
            },
            amount: 0,
            allMoney: 0,
            pages: 1,
            list: [],
            orderStatus: {
                id: null,
                show: false,
                status: '',
                statusArr: ['正常', '已退款', '已删除'],
                remark: ''
            }
        };
    },
    watch: {

    },
    async created() {
        this.getList();
    },
    mounted() {
    },
    methods: {
        moment,
        doSearch() {
            this.search.now_page = 1;
            this.getList();
        },
        async getList() {
            const r = await this.$axios.post("/shellCity/jiaofeiRecordList", this.search);
            for (let item of r.list) {
                item.gongxian_all = item.gongxian + item.admin_gongxian
            }
            this.list = r.list;
            this.amount = r.amount;
            this.allMoney = r.allMoney
        },
        onChange(e) {
            this.search.now_page = e;
            this.getList();
        },
        showCaozuo(item) {
            this.orderStatus.status = item.status
            this.orderStatus.id = item.id
            this.orderStatus.remark = item.remark
            this.orderStatus.show = true

        },
        cancelCaozuo() {
            this.orderStatus = {
                id: null,
                show: false,
                status: '',
                statusArr: ['正常', '已退款', '已删除'],
                remark: ''
            }
        },
        async doCaozuo() {
            const params = {
                id: this.orderStatus.id,
                status: this.orderStatus.status,
                remark: this.orderStatus.remark,
            }
            const r = await this.$axios.post("/shellCity/doJiaofeiStatus", params);
            if (r.status == 1) {
                this.cancelCaozuo()
                this.getList()
            }
        }
    },
};
</script>
  
<style></style>
